import createBrowserHistory from 'history/createBrowserHistory';
import createMemoryHistory from 'history/createMemoryHistory';

const history = process.env.REACT_APP_ROUTER ? createMemoryHistory() : createBrowserHistory();

export default history;



// WEBPACK FOOTER //
// ./src/history.js